import Box from '@mui/material/Box';
import logoSrc from '../../assets/img/trustlab-logo.png';

// Brand mark — uses the official TrustLab logo PNG.
// Sizes are tuned for navbar (md), drawer header (sm), and hero placements (lg).
const Logo = ({ onClick, size = 'md' }) => {
  const heights = { sm: 26, md: 36, lg: 52 };
  const h = heights[size] || heights.md;

  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        cursor: onClick ? 'pointer' : 'default',
        userSelect: 'none',
        lineHeight: 0,
      }}
    >
      <Box
        component="img"
        src={logoSrc}
        alt="TrustLab Diagnostics"
        sx={{
          height: h,
          width: 'auto',
          display: 'block',
        }}
      />
    </Box>
  );
};

export default Logo;
